import { BASE_URL } from '../components/AppConfig';
import { handleDynamicRequestHeader } from '../components/DyanamicRequest';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

export const getQuickLinks = async (limit = 50, offset = 0) => {
  return new Promise((resolve) => {
    const token = getAuthToken();
    const url = `${BASE_URL}/admin/quick-links?limit=${limit}&offset=${offset}`;
    handleDynamicRequestHeader(
      'GET',
      url,
      null,
      token,
      () => resolve({ statusCode: '50000', message: 'Failed to fetch quick links' }),
      (response) => resolve(response)
    );
  });
};

export const getQuickLinkById = async (id) => {
  return new Promise((resolve) => {
    const token = getAuthToken();
    handleDynamicRequestHeader(
      'GET',
      `${BASE_URL}/admin/quick-links/${id}`,
      null,
      token,
      () => resolve({ statusCode: '50000', message: 'Failed to fetch quick link' }),
      (response) => resolve(response)
    );
  });
};

export const createQuickLink = async (payload) => {
  return new Promise((resolve) => {
    const token = getAuthToken();
    handleDynamicRequestHeader(
      'POST',
      `${BASE_URL}/admin/quick-links`,
      payload,
      token,
      () => resolve({ statusCode: '50000', message: 'Failed to create quick link' }),
      (response) => resolve(response)
    );
  });
};

export const updateQuickLink = async (id, payload) => {
  return new Promise((resolve) => {
    const token = getAuthToken();
    handleDynamicRequestHeader(
      'PUT',
      `${BASE_URL}/admin/quick-links/${id}`,
      payload,
      token,
      () => resolve({ statusCode: '50000', message: 'Failed to update quick link' }),
      (response) => resolve(response)
    );
  });
};
